import React from "react";
import MarketIcon from "../../../../../assets/images/digitalized_orders/market.png";
import CalendarIcon from "../../../../../assets/images/digitalized_orders/calendar.png";
import EuroIcon from "../../../../../assets/images/digitalized_orders/euro.png";

const DigitalizedOrderCard = ({
  onClick,
  onKeyPress,
  shippingAddress,
  orderDate,
  creationDate,
  netPrice,
  grossPrice,
}) => {
  return (
    <div
      className="digitalized-orders__order"
      onClick={onClick}
      onKeyPress={onKeyPress}
    >
      <div className="digitalized-orders__order__row">
        <img
          src={MarketIcon}
          alt="Market Icon"
          className="digitalized-orders__order__row__icon"
        />
        <p className="digitalized-orders__order__row__text">
          {shippingAddress}
        </p>
      </div>

      <div className="digitalized-orders__order__row calendar-row">
        <img
          src={CalendarIcon}
          alt="Calendar Icon"
          className="digitalized-orders__order__row__icon"
        />
        <p className="digitalized-orders__order__row__text">
          Bestellung: {orderDate}
          <br />
          Auftrag gemeldet: {creationDate} <br />
        </p>
      </div>

      <div className="digitalized-orders__order__row">
        <img
          src={EuroIcon}
          alt="Euro Icon"
          className="digitalized-orders__order__row__icon"
        />
        <p className="digitalized-orders__order__row__text">
          Nettosumme: {netPrice}
          <br />
          Bruttosumme: {grossPrice}
          <br />
        </p>
      </div>
    </div>
  );
};

export default DigitalizedOrderCard;
